var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowbite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5196 13.4429C24.4455 13.9533 24.1089 14.6468 23.7228 15.2497C23.2356 16.0105 22.4625 16.5433 21.5776 16.7283L17.68 17.5434C17.0535 17.6744 16.4855 18.0022 16.0589 18.479L13.5033 21.3357C13.023 21.8725 12.6873 21.7445 12.6873 21.0244C12.6815 21.0511 11.4189 24.3072 14.7649 26.2371C16.0505 26.9787 17.9011 26.7122 19.1867 25.9707L25.9986 22.0416C28.5461 20.5721 30.3448 18.0863 30.9426 15.2089C30.9663 15.095 30.9845 14.9808 31.0042 14.8667L24.5196 13.4429Z",
    fill: "url(#paint0_linear_44_23797)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7528 9.51774C24.0384 10.2593 24.5637 11.3633 24.5637 12.8464C24.5637 13.0477 24.5479 13.2466 24.5194 13.4425L27.2641 14.6215L31.004 14.8663C31.4829 12.0948 30.5444 9.24202 28.862 6.97445C27.5959 5.268 25.9667 3.78713 24.0081 2.65738C22.417 1.73966 20.7636 1.135 19.1025 0.803223L17.2361 3.22023L16.6465 5.99559L22.7528 9.51774Z",
    fill: "url(#paint1_linear_44_23797)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.783597 11.5518C0.782899 11.554 0.784832 11.5546 0.78556 11.5524C0.929583 11.1205 1.11018 10.6385 1.33564 10.1237C2.51334 7.4343 4.78286 5.64062 7.57492 4.72608C10.367 3.81156 13.4155 4.13212 15.9601 5.59988L16.6465 5.99578L19.1025 0.803412C11.291 -0.756764 3.30728 3.83253 0.793528 11.5217C0.792327 11.5254 0.787957 11.5382 0.783597 11.5518Z",
    fill: "url(#paint2_linear_44_23797)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9199 25.9704C17.6343 26.712 16.0503 26.712 14.7647 25.9704C14.5902 25.8697 14.4257 25.7566 14.2701 25.634L12.0091 27.1885L10.0603 30.3376C12.2233 32.1377 15.0321 32.7164 17.839 32.3945C19.9513 32.1523 22.0495 31.4832 24.0082 30.3534C25.5992 29.4357 26.95 28.3075 28.0682 27.0361L26.9063 24.2128L25.0262 22.4482L18.9199 25.9704Z",
    fill: "url(#paint3_linear_44_23797)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2701 25.6341C13.2796 24.8539 12.6871 23.6572 12.6871 22.3754V22.2476V11.5724C12.6871 10.9687 12.865 10.8661 13.3884 11.168C12.5823 10.703 10.7203 9.10701 8.42118 10.4331C7.13557 11.1747 6.0769 12.8116 6.0769 14.2946V22.1529C6.0769 25.0917 7.59906 28.1573 9.79448 30.1133C9.88132 30.1906 9.97122 30.2636 10.0603 30.3377L14.2701 25.6341Z",
    fill: "url(#paint4_linear_44_23797)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9104 5.8123C27.9089 5.8106 27.9073 5.81197 27.9089 5.81368C28.2113 6.15428 28.5388 6.5515 28.8723 7.00399C30.6148 9.36764 31.2658 12.3613 30.6626 15.2343C30.0593 18.1072 28.2571 20.5846 25.7125 22.0523L25.0261 22.4482L28.0681 27.0361C33.3264 21.0576 33.34 11.8554 27.9315 5.83594C27.9289 5.83306 27.92 5.82287 27.9104 5.8123Z",
    fill: "url(#paint5_linear_44_23797)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34355 14.2948C6.34354 12.8117 7.13551 11.4413 8.42113 10.6998C8.59564 10.5991 8.77601 10.5133 8.96002 10.44L8.74304 7.70651L7.21861 4.5791C4.57671 5.55054 2.4397 7.55814 1.31528 10.1476C0.469097 12.0962 9.792e-06 14.2463 0 16.5057C0 18.3412 0.302549 20.074 0.845532 21.6772L3.87391 22.0835L6.34355 21.3391V14.2948Z",
    fill: "url(#paint6_linear_44_23797)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96016 10.44C10.1317 9.97312 11.4653 10.0589 12.5764 10.6998L12.6872 10.7637L21.5826 15.8946C22.2066 16.2545 22.1499 16.6087 21.4446 16.7561L21.9578 16.6488C22.633 16.5077 23.2499 16.1626 23.7217 15.6597C24.5328 14.7951 24.8306 13.752 24.8306 12.8467C24.8306 11.3637 24.0386 9.99323 22.753 9.25169L15.9411 5.32258C13.3936 3.85316 10.3395 3.53983 7.54622 4.46132C7.43572 4.49776 7.32756 4.53909 7.21875 4.5791L8.96016 10.44Z",
    fill: "url(#paint7_linear_44_23797)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3221 32.1528C19.3244 32.1523 19.3239 32.1503 19.3217 32.1508C18.8752 32.2422 18.3672 32.3269 17.8081 32.3892C14.888 32.715 11.9674 31.7814 9.77864 29.823C7.58986 27.8646 6.34347 25.0667 6.34348 22.1312L6.34347 21.3394L0.845459 21.6774C3.3988 29.2161 11.3689 33.8289 19.2911 32.1593C19.2949 32.1585 19.3082 32.1558 19.3221 32.1528Z",
    fill: "url(#paint8_linear_44_23797)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_23797",
    x1: 20.0602,
    y1: 24.2701,
    x2: 23.2077,
    y2: 13.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A3D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_23797",
    x1: 27.3093,
    y1: 10.9001,
    x2: 19.0297,
    y2: 2.64962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A3D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_23797",
    x1: 16.1645,
    y1: 5.52115,
    x2: 3.67432,
    y2: 6.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15A5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_23797",
    x1: 15.3198,
    y1: 29.1626,
    x2: 26.5366,
    y2: 26.1358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1395BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_44_23797",
    x1: 7.26881,
    y1: 16.1827,
    x2: 15.2325,
    y2: 24.4347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A7C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A3D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_44_23797",
    x1: 25.4504,
    y1: 22.1356,
    x2: 31.0069,
    y2: 10.9344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1395BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57B6D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_44_23797",
    x1: 5.36387,
    y1: 9.63116,
    x2: 2.39054,
    y2: 20.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA4D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_44_23797",
    x1: 20.5432,
    y1: 9.09961,
    x2: 9.6778,
    y2: 11.8049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C7EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18A3D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_44_23797",
    x1: 6.40667,
    y1: 21.8571,
    x2: 13.3324,
    y2: 32.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1395BF",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowbite);
export default __webpack_public_path__ + "static/media/flowbite.66dca1074199d84439e47c8e7ac59782.svg";
export { ForwardRef as ReactComponent };